/**
 * 登降園 時刻編集のモーダル
 * @param {*} $scope
 * @param {*} $modalInstance
 * @param {*} editItem
 */
function memberAttendanceEditTimeModalCtl($scope, $modalInstance, editItem) {
  $scope.time = editItem.time || new Date();
  $scope.m_step = editItem.m_step || 1;
  $scope.isSchedule = editItem.kind && editItem.kind.indexOf('attendSchedule') >= 0;
  $scope.ok = function () {
    $modalInstance.close({ time: $scope.time, index: editItem.index, kind: editItem.kind, type: editItem.type });
  };
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
}

angular.module('inspinia').controller('memberAttendanceEditTimeModalCtl', memberAttendanceEditTimeModalCtl);
